import React from 'react';
import InputField, {InputFieldProps} from "./InputField";

// Component ----

export type EmailFieldProps = Omit<InputFieldProps, 'type'>

function EmailField(props: EmailFieldProps) {
    return <InputField type="email" {...props} />
}

export default EmailField;